// import React, { useState, useEffect } from "react";
// import Sidebar from "../../CommonComponent/sidebar/Sidebar";
// import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
// import { Footer } from "../../Footer";
// import {
//   GetNotificationMes,
//   GetNotificationMesData,
//   NotificationReg,
// } from "../../redux/auth-reducer/auth-service";
// import dayjs from "dayjs";
// import { Button, Col, Form, Row } from "react-bootstrap";
// import * as icons from "react-bootstrap-icons";
// import { ModalBox } from "../Outer/Modal";
// import { ToastContainer, toast } from "react-toastify";

// const SuperNotification = () => {
//   const [data, setData] = useState(false);
//   const [itemData, setItemData] = useState([]);
//   const [itemLastData, setItemLastData] = useState([]);
//   const [notificationMes, setNotificationMes] = useState([]);
//   const [notificationsPerPage] = useState(10);
//   const [validated, setValidated] = useState(false);
//   const [activePage, setActivePage] = useState(1);
//   const [showView, setShowView] = useState(false);
//   const [count, setCount] = useState(0);
//   const [perPage, setPerPage] = useState(10);
//   const [totalRows, setTotalRows] = useState(1);
//   const [currentPage, setCurrentPage] = useState(1);
//   const pageOptions = [10, 20, 30, 50];
//   const [notificationReg, setNotificationReg] = useState({
//     message: "",
//   });

//   // useEffect(() => {
//   //   const NotificationMessageFun = async () => {
//   //     await GetNotificationMes().then((response) => {
//   //       setNotificationMes(response?.data?.dataList);
//   //     });
//   //   };
//   //   NotificationMessageFun();
//   // }, [count]);

//   const NotificationMessageFun = async (data) => {
//     try {
//       const response = await GetNotificationMesData(data); // Call your API function

//       setNotificationMes(response?.data?.dataList || []); // Set the item list
//       setTotalRows(response?.data?.totalPageSize || 0); // Set the total number of rows
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   useEffect(() => {
//     const data = {
//       PageNumber: currentPage,
//       PageSize: perPage,
//       SortOrder: false,
//     };
//     NotificationMessageFun(data); // Fetch data when currentPage changes
//   }, [currentPage, count]);

//   const handlePerPageChange = (event) => {
//     const newPerPage = Number(event.target.value);
//     const data = {
//       PageNumber: currentPage,
//       PageSize: newPerPage,
//       SortOrder: false,
//     };
//     NotificationMessageFun(data); // Get the new value

//     setPerPage(newPerPage); // Update items per page
//     setCurrentPage(1); // Reset to first page when items per page changes
//   };

//   // Handle page change
//   const handleNextPage = () => {
//     if (currentPage < Math.ceil(totalRows)) {
//       setCurrentPage((prevPage) => prevPage + 1); // Go to next page
//     }
//   };

//   const handlePreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage((prevPage) => prevPage - 1); // Go to previous page
//     }
//   };

//   // const handlePageChange = page => {
//   //     setPageNo(page);
//   //     const data = {
//   //         "PageNumber": page,
//   //         "PageSize": perPage
//   //     }
//   //     TeamAllFn(data);
//   // };

//   const indexOfLastNotification = currentPage * notificationsPerPage;
//   const indexOfFirstNotification =
//     indexOfLastNotification - notificationsPerPage;
//   const currentNotifications = notificationMes?.slice(
//     indexOfFirstNotification,
//     indexOfLastNotification
//   );

//   const paginate = (pageNumber) => {
//     setCurrentPage(pageNumber);
//     setActivePage(pageNumber);
//   };
//   // const totalPages = Math.ceil(notificationMes.length / notificationsPerPage);
//   const totalPages = Math.ceil(
//     (notificationMes?.length || 0) / notificationsPerPage
//   );
//   function convertUTCToLocalTime(utcDateString) {
//     const date = new Date(utcDateString);
//     return date.toString(); // Or use date.toLocaleString() for better format
//   }
//   const sidebarfun = () => {
//     setData(!data);
//   };
//   const viewFn = (viewItem) => {
//     setShowView(true);
//   };

//   const handleClosed = () => {
//     setShowView(false);
//     setValidated(false);
//   };
//   const heandelChange = (e) => {
//     setNotificationReg({
//       ...notificationReg,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     const form = event.currentTarget;
//     if (notificationReg?.message == "") {
//       return setValidated(true);
//     }
//     const registerData = {
//       message: notificationReg?.message,
//     };
//     await NotificationReg(registerData).then((res) => {
//       if (res) {
//         setCount(count + 1);
//         setShowView(false);
//         toast.success("Success");
//         setValidated(false);
//       } else {
//       }
//     });
//   };
//   return (
//     <>
//       <TopNavbar sidebarfun={sidebarfun} />
//       <div className="dasboard-group">
//         <Sidebar data={data} />
//         <div
//           className={
//             data ? "dashboard-content full-contnet" : "dashboard-content"
//           }
//         >
//           <Row className="d-flex align-items-center">
//             <Col md={6}>
//               <h1 className="heading-dash">Notification</h1>
//             </Col>
//             <Col md={6} className="text-right">
//               <Button
//                 className="primary button-create-auction btn btn-primary "
//                 onClick={() => viewFn()}
//               >
//                 <icons.Plus class="icon-plus" /> Broadcast Massage
//               </Button>
//             </Col>
//           </Row>
//           <div className="group_data_table">
//             <div className="notification_box">
//               {currentNotifications?.map((ele, index) => {
//                 const user = ele?.roleName.split(" ");

//                 // Get the first character of the first word
//                 const firstChar = user?.[0]?.charAt(0) || "";
//                 // Get the first character of the second word if it exists
//                 const secondChar = user?.[1]?.charAt(0) || "";

//                 return (
//                   <>
//                     <div className="notification p-2" key={ele.id}>
//                       <div className="notification-right">
//                         <div className="profile-pic2">
//                           {firstChar}
//                           {secondChar}
//                         </div>
//                         <div className="ms-3 notification-area">
//                           <h1>{ele?.roleName}</h1>
//                           <div className="noti-msg">{ele?.message}</div>

//                           <div className="Notification-Date">
//                             {dayjs(ele?.createDate + "Z").format(
//                               "MM/DD/YYYY hh:mm:ss A"
//                             )}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </>
//                 );
//               })}
//               {totalRows > 1 && (
//                 <Row>
//                   <Col md={12} className="text-right">
//                     <div className="pagination-controls">
//                       <label>Rows per page: </label>
//                       <select
//                         id="itemsPerPage"
//                         value={perPage}
//                         onChange={handlePerPageChange}
//                       >
//                         {pageOptions.map((option) => (
//                           <option key={option} value={option}>
//                             {option}
//                           </option>
//                         ))}
//                       </select>

//                       <Button
//                         onClick={handlePreviousPage}
//                         disabled={currentPage === 1}
//                       >
//                         <icons.ArrowLeft></icons.ArrowLeft>
//                       </Button>
//                       <span>
//                         {" "}
//                         {currentPage} of {totalRows}{" "}
//                       </span>
//                       <Button
//                         onClick={handleNextPage}
//                         disabled={currentPage >= Math.ceil(totalRows)}
//                       >
//                         <icons.ArrowRight></icons.ArrowRight>
//                       </Button>
//                     </div>
//                   </Col>
//                 </Row>
//               )}
//             </div>
//           </div>
//         </div>
//         <div className={data ? "Footer" : "footer-content"}>
//           <Footer />
//         </div>
//       </div>

//       <ModalBox
//         show={showView}
//         title={
//           <>
//             <h1 className="heading-dash">Add Broadcast Massage</h1>
//           </>
//         }
//         body={
//           <>
//             <Row>
//               <Col>
//                 <Form noValidate validated={validated} onSubmit={handleSubmit}>
//                   <Row className="mb-3">
//                     <Form.Group as={Col} md="12" controlId="validationCustom01">
//                       <Form.Label>Message</Form.Label>
//                       <Form.Control
//                         required
//                         as="textarea"
//                         name="message"
//                         rows={3}
//                         onChange={heandelChange}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         Please enter Message.
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Row>
//                   <Row>
//                     <Col md={6}></Col>
//                     <Col md={6} className="text-right">
//                       <Button
//                         type="button"
//                         className="btn-Cancel secondary  me-3 mb-3"
//                         onClick={handleClosed}
//                       >
//                         Cancel
//                       </Button>
//                       <Button type="submit" className="btn-Save  mb-3">
//                         Post
//                       </Button>
//                     </Col>
//                   </Row>
//                 </Form>
//               </Col>
//             </Row>
//           </>
//         }
//       />
//     </>
//   );
// };
// export default SuperNotification;


import React, { useState, useEffect } from "react";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import { Footer } from "../../Footer";
import {
  GetNotificationMesData,
  NotificationReg,
} from "../../redux/auth-reducer/auth-service";
import dayjs from "dayjs";
import { Button, Col, Form, Row } from "react-bootstrap";
import * as icons from "react-bootstrap-icons";
import { ModalBox } from "../Outer/Modal";
import { ToastContainer, toast } from "react-toastify";

const SuperNotification = () => {
  const [data, setData] = useState(false);
  const [notificationMes, setNotificationMes] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRecordCount, setTotalRecordCount] = useState(0);
  const [validated, setValidated] = useState(false);
  const [showView, setShowView] = useState(false);
  const [count, setCount] = useState(0);
  
  const pageOptions = [10, 20, 30, 50];
  const [notificationReg, setNotificationReg] = useState({
    message: "",
  });

  // Fetch Notification Messages
  const NotificationMessageFun = async (pageData) => {
    try {
      const response = await GetNotificationMesData(pageData);
      
      setNotificationMes(response?.data?.dataList || []); 
      setTotalRecordCount(response?.data?.totalRecordCount || 0);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Fetch data when page or per page changes
  useEffect(() => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };
    NotificationMessageFun(data);
  }, [currentPage, perPage, count]);

  // Handle change in rows per page
  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);
    setPerPage(newPerPage);
    setCurrentPage(1); // Reset to first page when items per page changes
  };

  // Handle page navigation
  const handleNextPage = () => {
    const totalPages = Math.ceil(totalRecordCount / perPage);
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  // Calculate total pages
  const totalPages = Math.ceil(totalRecordCount / perPage);

  // Sidebar toggle function
  const sidebarfun = () => {
    setData(!data);
  };

  // Open modal for adding notification
  const viewFn = () => {
    setShowView(true);
  };

  // Close modal
  const handleClosed = () => {
    setShowView(false);
    setValidated(false);
  };

  // Handle input change
  const heandelChange = (e) => {
    setNotificationReg({
      ...notificationReg,
      [e.target.name]: e.target.value,
    });
  };

  // Submit notification
  const handleSubmit = async (event) => {
    event.preventDefault();
    
    if (notificationReg?.message === "") {
      return setValidated(true);
    }
    
    try {
      const registerData = {
        message: notificationReg?.message,
      };
      
      const res = await NotificationReg(registerData);
      
      if (res) {
        setCount(count + 1);
        setShowView(false);
        toast.success("Success");
        setValidated(false);
        // Reset notification input
        setNotificationReg({ message: "" });
      }
    } catch (error) {
      toast.error("Failed to send notification");
    }
  };

  return (
    <>
      <TopNavbar sidebarfun={sidebarfun} />
      <div className="dasboard-group">
        <Sidebar data={data} />
        <div
          className={
            data ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <Row className="d-flex align-items-center">
            <Col md={6}>
              <h1 className="heading-dash">Notification</h1>
            </Col>
            <Col md={6} className="text-right">
              <Button
                className="primary button-create-auction btn btn-primary"
                onClick={viewFn}
              >
                <icons.Plus className="icon-plus" /> Broadcast Message
              </Button>
            </Col>
          </Row>
          
          <div className="group_data_table">
            <div className="notification_box">
              {notificationMes?.map((ele) => {
                // Extract initials from role name
                const user = ele?.roleName.split(" ");
                const firstChar = user?.[0]?.charAt(0) || "";
                const secondChar = user?.[1]?.charAt(0) || "";

                return (
                  <div className="notification p-2" key={ele.id}>
                    <div className="notification-right">
                      <div className="profile-pic2">
                        {firstChar}{secondChar}
                      </div>
                      <div className="ms-3 notification-area">
                        <h1>{ele?.roleName}</h1>
                        <div className="noti-msg">{ele?.message}</div>
                        <div className="Notification-Date">
                          {dayjs(ele?.createDate + "Z").format(
                            "MM/DD/YYYY hh:mm:ss A"
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}

              {totalRecordCount > 0 && (
                <Row>
                  <Col md={12} className="text-right">
                    <div className="pagination-controls">
                      <label>Rows per page: </label>
                      <select
                        id="itemsPerPage"
                        value={perPage}
                        onChange={handlePerPageChange}
                      >
                        {pageOptions.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>

                      <Button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                      >
                        <icons.ArrowLeft />
                      </Button>
                      <span>{" "}
                        {currentPage} of {totalPages} {" "}
                      </span>
                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage >= totalPages}
                      >
                        <icons.ArrowRight />
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          </div>
        </div>
        
        <div className={data ? "Footer" : "footer-content"}>
          <Footer />
        </div>
      </div>

      <ModalBox
        show={showView}
        title={<h1 className="heading-dash">Add Broadcast Message</h1>}
        body={
          <Row>
            <Col>
              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Row className="mb-3">
                  <Form.Group as={Col} md="12" controlId="validationCustom01">
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      required
                      as="textarea"
                      name="message"
                      rows={3}
                      value={notificationReg.message}
                      onChange={heandelChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter Message.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row>
                  <Col md={6}></Col>
                  <Col md={6} className="text-right">
                    <Button
                      type="button"
                      className="btn-Cancel secondary  me-3 mb-3"
                      onClick={handleClosed}
                    >
                      Cancel
                    </Button>
                    <Button type="submit" className="btn-Save  mb-3">
                      Post
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        }
      />
      <ToastContainer />
    </>
  );
};

export default SuperNotification;